import LandingDescription from './LandingDescription';

export default LandingDescription;
